/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import { getFirstOrganization, getCurrentUser } from '../utils/reduxHelpers';
import store from '../store/store';
import Types from '../constants/actionTypes';
import emailList from '../constants/emailList';
import routes from '../routes/routes';
import App from '../components/app';

const element = document.getElementById('card-wall');
const cadence = element && element.dataset.cadence;
const appBuild = JSON.parse(element.getAttribute('data'));

if (typeof cadence !== 'undefined') {
  store.dispatch({ type: Types.SET_CADENCE, cadence });
}

const { user } = store.getState().userReducer;

Bugsnag.start({
  apiKey: '1336db9bac04b09d578e71c789f2bbed',
  plugins: [new BugsnagPluginReact()],
  user: {
    email: user.uid
  },
  appVersion: appBuild.build
});

// const BugsnagBoundary = Bugsnag.getPlugin('react').createErrorBoundary(React);

const handleContactSupportClick = (props) => {
  const orgName = getFirstOrganization().name;
  const userName = getCurrentUser().name;
  window.location.href = `mailto:${
    emailList.support
  }?subject=${`${userName}-${orgName}-${props.build}`}`;
};

const appFooter = (props) => (
  <footer id="adz-footer" className="adz-footer">
    <div className="left">
      <span>Agile Dezign is an Integral Agile Inc product.</span>
    </div>
    <canvas id="text-sizer" /> {/* used to calculate text sizes */}
    <div className="right">
      <span
        className="contact"
        onClick={() => handleContactSupportClick(props)}
      >
        Contact Support
      </span>
      <span className="version">Build: {props.build}</span>
    </div>
  </footer>
);

const main = (
  <Provider store={store}>
    <Router>
      <App>
        <>
          {routes}
          {appFooter(appBuild)}
        </>
      </App>
    </Router>
  </Provider>
);

const appElement = element.appendChild(document.createElement('div'));
appElement.setAttribute('class', 'height-100');

const portalElement = element.appendChild(document.createElement('div'));
portalElement.setAttribute('class', 'portal-element');

document.addEventListener('DOMContentLoaded', () => render(main, appElement));
